<div class="rxap-container shadow-lg hover:shadow-xl flex flex-row gap-1">
  <button (click)="confirmed.emit()" class="accept" mat-icon-button type="button">
    <mat-icon>done</mat-icon>
  </button>
  <button (click)="unconfirmed.emit()" class="decline" mat-icon-button type="button">
    <mat-icon>clear</mat-icon>
  </button>
</div>
